import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Resources from "../../resources/mlp-resources.json"
import PropTypes from "prop-types"
import AdministrationImage from "../images/svg/trazado151.svg"
import MonetizationImage from "../images/svg/ahorro.svg"
import HospitableImage from "../images/svg/hospital.svg"
import BorrowImage from "../images/svg/contrato.svg"
import DebtImage from "../images/svg/dinero.svg"
import InvestmentImage from "../images/svg/prestamo.svg"

const AreaItemWrapper = styled.div`
  width: 100%;
  height: auto;
  display: block;

  :hover {
    cursor: pointer;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    display: grid;
    grid-template-columns: 0.2fr 0.8fr;
    grid-gap: 1em;
    justify-content: flex-start;
    align-items: center;
  }
`

const AreaItemImgWrapper = styled.div`
  background-color: var(${Resources.areas_esp.bg_color2});
  border-radius: 50%;
  width: 100px;
  height: 100px;
  padding: 15px;
  margin: 15px auto;
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 30px;

  .img {
    width: 70px;
    height: 70px;
    display: block;
    margin: auto;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0;

    .img {
      max-height: 100%;
    }
  }
`

const AreaItemTextWrapper = styled.div`
  font-family: var(${Resources.areas_esp.font});
  font-size: ${Resources.areas_esp.size};
  color: var(${Resources.areas_esp.color});
  text-align: center;

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    text-align: left;
  }

  .accent-text {
    color: var(${Resources.areas_esp.title.color}) !important;
    font-weight: bold !important;
  }
`

const AreaItemDescription = styled.p`
  margin-top: 8px;
  font-family: var(--font-md);
  font-size: 0.9em;
  color: var(${Resources.areas_esp.color});
  line-height: 1.7em;
`

const AREA_CONTENT = {
  administration: {
    title: "Dictámenes Técnicos",
    description:
      "Elaboración de evaluaciones especializadas que respaldan decisiones clave con base en criterios técnicos, normativos y de viabilidad.",
  },
  debt: {
    title: "Estudios de Factibilidad",
    description:
      "Análisis integral de proyectos para determinar su viabilidad técnica, financiera y operativa antes de su implementación.",
  },
  borrow: {
    title: "Consultoría en Inversión",
    description:
      "Asesoramiento estratégico para optimizar decisiones de inversión, identificando riesgos, oportunidades y escenarios de rentabilidad.",
  },
  money: {
    title: "Estructuación de Financiamientos",
    description:
      "Diseño de esquemas financieros a la medida para proyectos públicos y privados, facilitando el acceso a capital y fuentes de financiamiento.",
  },
  // debt: {
  //   title: "Análisis de Deuda",
  //   description:
  //     "Evaluación y recomendaciones para la gestión de deuda, incluyendo estrategias de reestructuración y optimización de costos.",
  // },
  // investment: {
  //   title: "Evaluación de Inversiones",
  //   description:
  //     "Análisis detallado de oportunidades de inversión, incluyendo evaluación de riesgos, retornos potenciales y recomendaciones de inversión.",
  // },
}

const AreaItem = ({ type }) => {
  const [showDescription, setShowDescription] = useState(false)
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const hasTouch =
        "ontouchstart" in window ||
        (navigator &&
          (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0))
      setIsTouchDevice(!!hasTouch)
    }
  }, [])

  let image
  switch (type) {
    case "administration":
      image = <AdministrationImage className="img" />
      break
    case "monetization":
      image = <MonetizationImage className="img" />
      break
    case "hospitable":
      image = <HospitableImage className="img" />
      break
    case "borrow":
      image = <BorrowImage className="img" />
      break
    case "debt":
      image = <DebtImage className="img" />
      break
    default:
      image = <InvestmentImage className="img" />
      break
  }

  const { title, description } =
    AREA_CONTENT[type] || AREA_CONTENT.administration

  const handleMouseEnter = () => {
    if (!isTouchDevice) {
      setShowDescription(true)
    }
  }

  const handleMouseLeave = () => {
    if (!isTouchDevice) {
      setShowDescription(false)
    }
  }

  const handleClick = () => {
    if (isTouchDevice) {
      setShowDescription(prev => !prev)
    }
  }

  return (
    <AreaItemWrapper
      className="svg-icon"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <AreaItemImgWrapper>{image}</AreaItemImgWrapper>
      <AreaItemTextWrapper>
        <div className="accent-text">{title}</div>
        {showDescription && (
          <AreaItemDescription>{description}</AreaItemDescription>
        )}
      </AreaItemTextWrapper>
    </AreaItemWrapper>
  )
}

AreaItem.propTypes = {
  type: PropTypes.oneOf([
    "administration",
    "monetization",
    "hospitable",
    "borrow",
    "debt",
    "investment",
  ]),
}

AreaItem.defaultProps = {
  type: "investment",
}

export default AreaItem
